import React, { useState } from "react";
import styles from "../CreateProvider/CreateProvider.module.css";
import Select from "react-select";
import { createProviderTool } from "../../Services/Provider/providerService";
import { ToolTypeOptions } from "../../Utils/constants";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader";
import GeneralToast from "../Toaster";

const CreateTool = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    providerId: "",
    version: 1,
    type: "",
    description: "",
    externalId: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage("");
    const payload = {
      input: {
        entityType: "Tool",
        entityToCreate: {
          Tool: { ...formData },
        },
      },
    };
    createProviderTool(payload)
      .then((res) => {
        setIsLoading(false);
        if (res?.data?.status === 200) {
          navigate("/provider/tool/view");
        } else {
          setErrorMessage(
            res?.response?.data?.errorMessage ||
              res?.message ||
              "Something went wrong"
          );
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setErrorMessage("Something went wrong");
      });
  };

  return (
    <>
      {isLoading && <Loader />}
      <p className="flex items-center justify-center mt-20 text-lg text-[#0e76a8]">
        <b>Add Tool</b>
      </p>
      <div style={{ maxWidth: "500px", margin: "0 auto", padding: "20px" }}>
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroupStyle}>
            <label htmlFor="name" className={styles.labelStyle}>
              Name: <span className="text-red-700">*</span>
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className={styles.inputStyle}
              required
            />
          </div>

          <div className={styles.formGroupStyle}>
            <label htmlFor="providerId" className={styles.labelStyle}>
              Provider ID: <span className="text-red-700">*</span>
            </label>
            <input
              type="text"
              id="providerId"
              name="providerId"
              value={formData.providerId}
              onChange={handleChange}
              className={styles.inputStyle}
              required
            />
          </div>

          <div className={styles.formGroupStyle}>
            <label htmlFor="type" className={styles.labelStyle}>
              Type: <span className="text-red-700">*</span>
            </label>
            <Select
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  width: 300,
                  border: `1px solid ${
                    state.isFocused ? "#0e76a8" : "#cccccc"
                  }`,
                  borderRadius: "4px",
                  boxShadow: state.isFocused
                    ? "0 0 5px rgba(14, 118, 168, 0.5)"
                    : "none",
                  transition: "border-color 0.3s ease",
                }),
                option: (baseStyles, { isFocused, isSelected }) => ({
                  ...baseStyles,
                  backgroundColor: isSelected
                    ? "#0e76a8"
                    : isFocused
                    ? "#0e76a861"
                    : "#ffffff",
                  color: isSelected ? "white" : "black",
                  padding: 10,
                }),
              }}
              defaultValue={ToolTypeOptions.find(
                (option) => option.value === formData.type
              )}
              options={ToolTypeOptions}
              onChange={(selectedOption) =>
                setFormData({ ...formData, type: selectedOption?.value || "" })
              }
              required
            />
          </div>

          <div className={styles.formGroupStyle}>
            <label htmlFor="description" className={styles.labelStyle}>
              Description: <span className="text-red-700">*</span>
            </label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              className={styles.inputStyle}
              required
            />
          </div>

          <div className={styles.formGroupStyle}>
            <label htmlFor="externalId" className={styles.labelStyle}>
              External ID:
            </label>
            <input
              type="text"
              id="externalId"
              name="externalId"
              value={formData.externalId}
              onChange={handleChange}
              className={styles.inputStyle}
            />
          </div>
          <button type="submit" className={styles.submit}>
            Submit
          </button>
        </form>
      </div>
      {errorMessage && <GeneralToast type="error" message={errorMessage} />}
    </>
  );
};

export default CreateTool;
